// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA-kod3d39iPFPyjG6i9I2dVRiNy4CG9rg",
    authDomain: "friendly-face-dd670.firebaseapp.com",
    databaseURL: "https://friendly-face-dd670.firebaseio.com",
    projectId: "friendly-face-dd670",
    storageBucket: "friendly-face-dd670.appspot.com",
    messagingSenderId: "636380047065",
    appId: "1:636380047065:web:0c8b7937544e01c0cb40c8",
    measurementId: "G-CLPJR6XSFG"
  },
  endpoint:'https://friendlyface.cognitiveservices.azure.com/face/v1.0/detect',
  identifyEndpoint:'https://friendlyface.cognitiveservices.azure.com/face/v1.0/identify',
  faceKey1:"e13626ae0a4844c395b807c27a270fd9",
  faceKey2:"1820389ed2f4444099ebb8a74bcab600",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
